<bn-loading-overlay></bn-loading-overlay>

<div class="container" *ngIf="solicitacaoDevolucao; else carregando">

    <div class="row">
        <div class="col">
            <h3>Detalhes da solicitação <small class="text-muted">(#ID: {{solicitacaoDevolucao?.id}})</small></h3>
        </div>
        <div class="col-auto">
            <button class="btn btn-primary" type="button" (click)="voltarParaLista ()">Voltar</button>
            <button *ngIf="habilitadoCancelar()" 
                    [disabled]="solicitacaoDevolucao.estado.id != 1 && solicitacaoDevolucao.estado.id != 2 "
                    class="btn btn-light" type="button" (click)="abrirModalConfirmacao(false)">Cancelar</button>
        </div>
    </div>

    <ul ngbNav #nav="ngbNav" [(activeId)]="active" class="col nav-tabs">
    
        <li title="Solicitação de devolução" [ngbNavItem]>
            <a ngbNavLink>Solicitação de devolução</a>
            <ng-template ngbNavContent>
    
                <div class="row">
                    <div [ngClass]="'bn-form-group ' + (solicitacaoDevolucao.sistemaRepasse ? 'col-md-4' : 'col-md-6')">
                        <label><b>Agente financeiro</b></label>
                        <input type="text" class="form-control" name="nomeAgenteFinanceiro"
                            value="{{nomeAgente(solicitacaoDevolucao.cnpjAgenteFinanceiro)}}" disabled />
                    </div>
                    <div [ngClass]="'bn-form-group ' + (solicitacaoDevolucao.sistemaRepasse ? 'col-md-3' : 'col-md-6')"
                        *ngIf="solicitacaoDevolucao.idOperacaoExterno">
                        <label><b>Id. operação agente</b></label>
                        <input type="text" class="form-control" name="idOperacaoAgente"
                            value="{{solicitacaoDevolucao.idOperacaoExterno}}" disabled />
                    </div>
                    <div class="bn-form-group col-md-2" *ngIf="solicitacaoDevolucao.sistemaRepasse">
                        <label><b>Sistema</b></label>
                        <input type="text" class="form-control" value="{{solicitacaoDevolucao.sistemaRepasse}}"
                            disabled />
                    </div>
                    <div class="bn-form-group col-md-3" *ngIf="solicitacaoDevolucao.contratoRepasse">
                        <label><b>Contrato</b></label>
                        <div class="input-group">
                            <input type="text" class="form-control" [value]="solicitacaoDevolucao.contratoRepasse"
                                disabled />
                            <span class="input-group-text" *ngIf="permissaoLinkN03 && solicitacaoDevolucao.contratoRepasse">
                                <a href="/n03_spa/#!/amb-ope/subcredito/documento-nivel/numero/{{solicitacaoDevolucao.contratoRepasse}}">
                                    <i class="fa fa-external-link-alt" ngbTooltip="Acessar Operação"></i>
                                </a>
                            </span>
                        </div>
                    </div>
                </div>
    
                <div class="row">
                    <div class="bn-form-group col-md-4">
                        <label><b>Estado</b></label>
                        <input type="text" class="form-control" name="nomeEstado"
                            value="{{solicitacaoDevolucao.estado.nomeEstado}}" disabled />
                    </div>

                    <div class="col-8">
                        <label><b>Motivo da transição de estado</b></label>
                        <input type="text" class="form-control" name="motivoEstado"
                            value="{{solicitacaoDevolucao.estado.motivoEstado}}" disabled />
                    </div>

                </div>
                <div class="row">

                    <div class="bn-form-group col-md-2">
                        <label><b>Data de envio</b></label>
                        <bn-datepicker name="dataEnvio" [(ngModel)]="solicitacaoDevolucao.dataEnvio" disabled>
                        </bn-datepicker>
                    </div>
                    <div class="bn-form-group col-md-2">
                        <label><b>Data de aprovação</b></label>
                        <bn-datepicker name="dataAprovacao" [(ngModel)]="solicitacaoDevolucao.dataAprovacao"
                            disabled>
                        </bn-datepicker>
                    </div>
                    <div class="bn-form-group col-md-4">
                        <label><b>Valor honrado a recuperar</b></label>
                        <input type="text" class="form-control moeda" name="valorPagoEmReais"  [(ngModel)]="solicitacaoDevolucao.valorHonradoARecuperarNaDataDeAprovacao" bnMask="MOEDA" disabled />
                    </div>
                    <div class="bn-form-group col-md-2">
                        <label><b>Id. cobrança</b></label>
                        <div class="input-group">
                            <input type="text" class="form-control" name="idCobranca"
                                value="{{solicitacaoDevolucao?.identificadorCobranca}}" disabled />
                            <span class="input-group-text" *ngIf="solicitacaoDevolucao?.identificadorCobranca">
                                <a href="#/cobrancas/{{solicitacaoDevolucao?.identificadorCobranca}}">
                                    <i class="fa fa-external-link-alt" ngbTooltip="Ver detalhes da cobrança"></i>
                                </a>
                            </span>
                        </div>
                    </div>
                    <div class="bn-form-group col-md-2">
                        <label><b>Estorno Manual</b></label>
                        <select class="form-select" id="estornoManual" name="estornoManual" [(ngModel)]="estornoManual" 
                            (change)="abrirModalConfirmarAlteracaoEstorno()"
                            [disabled]="!(podeLancarEstorno && solicitacaoDevolucao?.estado.id == 6)">
                            <option [ngValue]=undefined></option>
                            <option [value]="item.valor" *ngFor="let item of tiposEstorno">
                                {{item.nome}}
                            </option>
                        </select>
                    </div>
                </div>


        
            </ng-template>

        </li>
    
    
        <li title="Histórico" *ngIf="solicitacaoDevolucao.historicoEstados?.length > 0" [ngbNavItem]>
            <a ngbNavLink>Histórico</a>
            <ng-template ngbNavContent>
                <div class="table-responsive">
                    <table class="table table-hover">
                        <thead>
                            <tr>
                                <th scope="col">Data</th>
                                <th scope="col">Estado</th>
                                <th scope="col">Motivo</th>
                                <th scope="col">Responsável</th>
                            <tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let hist of solicitacaoDevolucao.historicoEstados">
                                <td>{{ hist.dataUltimaAtualizacao | date:'dd/MM/yyyy H:mm'}}</td>
                                <td>{{ hist.estado.nomeEstado }}</td>
                                <td>{{ hist.estado.motivoEstado}}</td>
                                <td>{{ hist.nomeUsuarioResponsavel}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </ng-template>
        </li>
    </ul>
    <div [ngbNavOutlet]="nav"></div>
    </div>

<ng-template #cancelamento>
    <label>Tem certeza de que deseja cancelar a solicitação de devolução de honra?</label>
</ng-template>
<ng-template #botoesDeAcao>
    <button class="btn btn-default" (click)="desistirDoCancelamento()">Cancelar</button>
    <button class="btn btn-primary" (click)="confirmarCancelamento()">Confirmar</button>
</ng-template>

<ng-template #confirmEstorno>
  <span> Confirma a alteração no campo Estorno Manual? </span>
  <br />
</ng-template>
<ng-template #confirmEstornoBotoes>
  <button class="btn btn-md btn-success" (click)="atualizaEstornoManual()">Sim</button>
  <button class="btn btn-md btn-danger" (click)="cancelarEstorno()">Não</button>
</ng-template>

<div class="container row" *ngIf="ocorrencias?.length > 0">
    <div class="table-responsive">
        <table class="table-striped table-bordered">
            <thead>
                <tr>
                    <th class="text-center">Erro(s) encontrado(s)</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let ocorrencia of ocorrencias">
                    <td>{{ ocorrencia.mensagem }}</td>
                </tr>
            </tbody>
        </table>
    </div>
</div>

<ng-template #carregando>
    <div class="loading-pesquisa">
        <i class="bn-loading"></i>
    </div>
</ng-template>